const steps = [
  {
    number: "01",
    icon: "ri-building-2-line",
    title: "Concrete moves every day",
    desc: "Due to temperature changes, structural load, and natural settlement — micro-cracks form throughout the concrete matrix. These cracks are invisible to the naked eye but very real.",
    highlight: "Micro-cracks form",
  },
  {
    number: "02",
    icon: "ri-drop-line",
    title: "Water finds those micro-cracks",
    desc: "Water travels through the internal pathways — not on the surface. It enters at one point and emerges far from the source, making it nearly impossible to locate with visual inspection.",
    highlight: "Travels inside, emerges elsewhere",
  },
  {
    number: "03",
    icon: "ri-tools-line",
    title: "Surface treatments seal the exit — not the source",
    desc: "Patching, coatings, and membranes block where the water comes out. But the internal pathway remains open. Water builds pressure and finds another exit. The leak returns.",
    highlight: "Leak always returns",
  },
];

export default function EducationSection() {
  return (
    <section id="education" className="bg-[#f0f4f8] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#4a7fa5] font-bold uppercase tracking-widest text-sm mb-3">Why Surface Repairs Always Fail</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0a0e1a] max-w-3xl mx-auto leading-tight">
            The water doesn&apos;t travel on the surface.{" "}
            <span className="text-[#1a3a5c]">It travels inside the concrete.</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14">
          {steps.map((step, idx) => (
            <div key={step.number} className="relative bg-white rounded-lg p-8 border border-gray-200">
              {/* Connector line */}
              {idx < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 -right-4 w-8 h-0.5 bg-[#4a7fa5]/30 z-10"></div>
              )}
              <div className="flex items-center gap-3 mb-5">
                <span className="text-4xl font-black text-[#1a3a5c]/20 leading-none">{step.number}</span>
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1a3a5c]/10">
                  <i className={`${step.icon} text-[#4a7fa5] text-lg`}></i>
                </div>
              </div>
              <h3 className="text-[#0a0e1a] font-bold text-lg mb-3">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{step.desc}</p>
              <span className="inline-block bg-red-50 text-red-600 text-xs font-bold px-3 py-1 rounded-full border border-red-200">
                {step.highlight}
              </span>
            </div>
          ))}
        </div>

        {/* Bold statement */}
        <div className="bg-[#0a0e1a] rounded-lg px-8 py-7 max-w-4xl mx-auto text-center">
          <p className="text-white text-lg md:text-xl font-bold leading-relaxed">
            &ldquo;Patching the surface without treating the internal pathway is like putting tape over a hole in a pipe.{" "}
            <span className="text-[#4a7fa5]">The pressure always wins.</span>&rdquo;
          </p>
        </div>
      </div>
    </section>
  );
}
